
import React from "react";
import { BackButton as SharedBackButton } from "@/components/shared/BackButton";

interface BackButtonProps {
  borderClass: string;
}

const BackButton = ({ borderClass }: BackButtonProps) => {
  return (
    <SharedBackButton 
      borderClass={borderClass}
      tooltip="Go back"
    />
  );
};

export default BackButton;
